import React from 'react';

function rosette(phase) {
  return (
    Array.from({ length: 241 }, (_, index) => {
      const angle = (index / 240) * Math.PI * 2;
      const radius = 65 + 6 * Math.cos(angle * 12 + phase);
      return `${index ? 'L' : 'M'}${(80 + radius * Math.cos(angle)).toFixed(
        2
      )} ${(80 + radius * Math.sin(angle)).toFixed(2)}`;
    }).join(' ') + 'Z'
  );
}

const sealContours = [rosette(0), rosette(Math.PI)];

// Heroicons v2.1.5, MIT. Attribution: public/third-party/heroicons/.
const shieldCheckPath =
  'M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z';

export function OfficialShieldV115({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      aria-hidden='true'
      focusable='false'
    >
      <path d={shieldCheckPath} fillRule='evenodd' clipRule='evenodd' />
    </svg>
  );
}

// Certificate-style linework is decorative, not an external certification mark.
export function OfficialSealV115({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox='0 0 160 160'
      fill='none'
      aria-hidden='true'
      focusable='false'
    >
      <g stroke='currentColor'>
        {sealContours.map((d, index) => (
          <path key={index} d={d} strokeWidth='.7' />
        ))}
        <circle cx='80' cy='80' r='56' strokeWidth='.75' />
        <circle cx='80' cy='80' r='52' strokeWidth='.6' strokeDasharray='1 3' />
        <circle cx='80' cy='80' r='47' strokeWidth='.75' />
        <path
          d={shieldCheckPath}
          transform='translate(52 48) scale(2.333333)'
          fill='currentColor'
          stroke='none'
          fillRule='evenodd'
          clipRule='evenodd'
        />
        <path d='M74 119h12M78 123h4' strokeWidth='1' strokeLinecap='round' />
      </g>
    </svg>
  );
}

export function OfficialEngravingV115() {
  return (
    <svg
      className='model-official-engraving-v115'
      viewBox='0 0 800 260'
      fill='none'
      aria-hidden='true'
      focusable='false'
    >
      {Array.from({ length: 10 }, (_, index) => (
        <path
          key={index}
          d={`M-40 ${285 - index * 9}C150 ${65 - index * 9} 220 ${
            330 - index * 9
          } 420 ${190 - index * 9}S650 ${-20 - index * 9} 840 ${
            105 - index * 9
          }`}
          stroke='currentColor'
          strokeWidth='.75'
        />
      ))}
    </svg>
  );
}

export function OfficialCheckV115() {
  return (
    <svg
      className='model-official-check-v115'
      viewBox='0 0 20 20'
      fill='none'
      aria-hidden='true'
      focusable='false'
    >
      <circle cx='10' cy='10' r='8' fill='currentColor' fillOpacity='.12' />
      <circle
        cx='10'
        cy='10'
        r='7.5'
        stroke='currentColor'
        strokeOpacity='.45'
      />
      <path
        d='m6.5 10 2.4 2.5 4.6-5'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
